import { render } from "./App.provider.vue?vue&type=template&id=0b33deec"
import script from "./App.provider.vue?vue&type=script&lang=js"
export * from "./App.provider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__